import actions from './actions'
import mutations from './mutations'

const state = {
  all_schools: []
}
export default {
  state, mutations, actions
}
